import { useEffect, useState } from "react";

import {
  Dataset,
  DatasetDetailResponse,
  H3Configuration
} from "@/types/dataset";

export const useH3Configuration = ({
  dataset,
  selectedDataset
}: {
  dataset?: Dataset;
  selectedDataset: DatasetDetailResponse | null;
}) => {
  const [h3Configuration, setH3Configuration] =
    useState<H3Configuration | null>(null);

  useEffect(() => {
    if (dataset?.h3Configuration) {
      setH3Configuration(dataset.h3Configuration);
    }
  }, [dataset]);

  useEffect(() => {
    if (
      selectedDataset?.source === "bvt" &&
      selectedDataset?.spatial_aggregation_type === "H3"
    ) {
      setH3Configuration({
        aggregationType: "AVG",
        resolution: selectedDataset?.grid_level || 8
      });
    } else {
      setH3Configuration(null);
    }
  }, [selectedDataset]);

  return { h3Configuration, setH3Configuration };
};
